require('./cardCancelDeferPurchaseStep2.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');

// @commons
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');

// @constants
const {
    CARD_CANCEL_DEFER_PURCHASE_SIGNATURE_PATTERN_TYPE,
} = require('constants/operationTypes');

class cardCancelDeferPurchaseStep2 extends React.Component {

    render() {
        const { movementId, immCard, immCardsTransactions, informativeList, reset } = this.props
        const confirmationMessage = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_redirectConfirmationMessage" />);
        const confirmationTitle = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_redirectConfirmationTitle" />);
        const acceptText = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_redirectConfirmationAcceptButton" />);
        const cancelText = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_redirectConfirmationCancelButton" />);
        const cardId= immCard.get('cardId');
        const immMovement = immCardsTransactions.getIn([cardId, 'byId', movementId]);
        const operationDate = immMovement.getIn(['extra', 'movementNoteDay']);
        const FormattedoperationDate = moment(operationDate).format('DD-MM-YYYY');
        const operationParams = {
            "pan": nonNumericFilter(immCard.get('number')),
            "optional1": (immMovement.getIn(['extra', 'dayMovementNumber'])).toString(),
            "optional2": FormattedoperationDate
        }
        return (
            <div className="card-cancel-defer-purchase-step2">
                <div className="card-cancel-defer-purchase-step2__title">
                    <FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_confirmationTitle" />
                </div>
                <div className="card-cancel-defer-purchase-step2__content">
                    {informativeList}
                </div>
                <div className="card-cancel-defer-purchase-step2__signature-pattern">
                    <SignaturePattern
                        operationType={CARD_CANCEL_DEFER_PURCHASE_SIGNATURE_PATTERN_TYPE}
                        operationParams={operationParams}
                    />
                </div>
                <PreLeaveModalComponent
                    acceptText={acceptText}
                    cancelText={cancelText}
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    isReady={this.isReady}
                    onConfirmLeave={reset}
                />
            </div>
        );
    }
}

cardCancelDeferPurchaseStep2.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object.isRequired,
    informativeList: PropTypes.any,
    movementId: PropTypes.object.isRequired,
    onHandleToggleModal: PropTypes.func,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    showErrorPopup: PropTypes.bool,
};

module.exports = cardCancelDeferPurchaseStep2;
